module.exports = __webpack_public_path__ + "img/recording-dot.6fcca92c.gif";